import React from "react";
import { Grid } from "@mui/material";
import { AutocompleteInput, ReferenceInput, SelectInput } from "react-admin";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { administrationRequests } from "api/administrationApi";

const EditForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="buildingId"
          reference={administrationRequests.getBuildingsSelect()}
          label="Сграда"
        >
          <AutocompleteInput
            label="Сграда"
            optionText="name"
            optionValue="id"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="wardId"
          reference={administrationRequests.getWardsSelect()}
        >
          <SelectInput
            optionText="name"
            label="Болнично отделение"
            emptyText={false}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ProfessorInput source="employeeId" />
      </Grid>
    </Grid>
  );
};

export default EditForm;
